var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('model-list-select',{staticClass:"select-option",attrs:{"list":_vm.list,"option-text":"text","option-value":"value","required":true,"value":_vm.computedValue,"placeholder":_vm.placeholder},on:{"input":_vm.input},model:{value:(_vm.modValue),callback:function ($$v) {_vm.modValue=$$v},expression:"modValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }